<template>
    <div v-show="loading" class="lds-ring" >
        <div></div><div></div><div></div><div></div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'






export default defineComponent({
    name: 'RingLoader',
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
    }
})
</script>

<style scoped>
</style>